import utils from "@/utils/utils.js";
const mixin = {
    methods: {
        $t(key) {
            return utils.$t(key)
        },
        copy(str) {
            return utils.copy(str)
        },
		goToPage(path, options = '') {
			utils.goToPage(path, options)
		}
    }
}

export default mixin